export default __webpack_public_path__ + "static/media/envelope.2a333431.svg";